<template>
  <section class="bg-white border-b border-gray-100 p-6 mt-10">
    <level :full="true">
      <div class="flex items-center justify-between w-full text-3xl font-semibold leading-tight">
        <slot />
      </div>
    </level>
  </section>
</template>

<script>
import Level from '@/Components/Dashboard/Level'

export default {
  name: 'HeroBar',
  components: {
    Level
  }
}
</script>
